import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';
import { ChangePasswordPage } from '../features/auth/components/ChangePasswordPage';

const changePasswordSearchSchema = z.object({
  axprtl: z.string().optional(),
});

export const Route = createFileRoute('/reset')({
  validateSearch: changePasswordSearchSchema,
  beforeLoad: ({ search }) => {
    if (!search.axprtl) {
      throw redirect({ to: '/login' });
    }
  },
  component: ResetPage,
});

function ResetPage() {
  const { axprtl } = Route.useSearch();
  return <ChangePasswordPage axprtl={axprtl} />;
}
